import axiosInstance from './axiosInstance';
import { API_PATH, API_VERSION } from './constants';

const triggerService = {
    triggerEngagement: (companyId, triggerName, startRange, endRange, isDTC = true) => axiosInstance.get(
        `/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.ENGAGEMENT}/${API_PATH.TRIGGERS}/${triggerName}/${startRange}/${endRange}/${isDTC}`
    ),

    triggerEngagementPaginate: (
        companyId,
        triggerName,
        startRange, 
        endRange,
        batchNo,
        batchSize
    ) => axiosInstance.get(
        `/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.ENGAGEMENT}/${API_PATH.TRIGGER_PAGINATE}/${triggerName}/${startRange}/${endRange}/${batchNo}/${batchSize}`
    ),

    triggersEngagement: (companyId, startRange, endRange, isUnified=true) => axiosInstance.get(
        `/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.ENGAGEMENT}/${API_PATH.TRIGGERS}/${startRange}/${endRange}/${isUnified}`
    ),

    getAllTriggers: (companyId) => axiosInstance.get(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.TRIGGERS}`),

    dataInputs: (companyId) => axiosInstance.get(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.TRIGGERS}/${API_PATH.DATAINPUTS}`),

    getQueryPreview: (companyId, data) => axiosInstance.post(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.TRIGGERS}/${API_PATH.PREVIEW}`,data),

    getTriggerById: (companyId, triggerId) => axiosInstance.get(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.TRIGGERS}/${triggerId}`), 

    createTrigger: (companyId, data) => axiosInstance.post(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.TRIGGERS}`, data),

    updateTriggerById: (companyId, triggerId, data) => axiosInstance.put(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.TRIGGERS}/${triggerId}`, data),

    deleteQuery: (companyId, data) => axiosInstance.post(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.TRIGGERS}/${API_PATH.DELETE}`, data),

    getTriggersSummaryPaginate: (
        companyId,
        startRange, 
        endRange,
        batchNo,
        batchSize,
        isUnified=true,
        triggerNames
        
    ) => axiosInstance.post(
        `/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.ENGAGEMENT}/${API_PATH.TRIGGER_Multiple_PAGINATE}/${startRange}/${endRange}/${batchNo}/${batchSize}/${isUnified}`, triggerNames
    ),

    getTriggersSummaryGraphs: (
        companyId,
        startRange, 
        endRange,
        isUnified=true,
        triggerNames
    ) => axiosInstance.post(
        `/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.ENGAGEMENT}/${API_PATH.TRIGGER_Multiple_GRAPH_DATA}/${startRange}/${endRange}/${isUnified}`, triggerNames
    ),
    getWebMatrixPatientTrigger: (companyId, startRange, endRange,triggerName) => axiosInstance.get(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.ENGAGEMENT}/${API_PATH.WEB_MATRIX_PATIENT}/${startRange}/${endRange}/${false}/${triggerName}`),
    getWebMatrixPatientAnalysisSummaryTrigger: (companyId, startRange, endRange,page_no,page_size,triggerName) => axiosInstance.get(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.ENGAGEMENT}/${API_PATH.WEB_MATRIX_PATIENT_ANALYSIS_SUMMARY}/${startRange}/${endRange}/${page_no}/${page_size}/${false}`) // /${triggerName} this will added once data will come for triggers.
};



export default triggerService;
